export default __webpack_public_path__ + "static/media/nave-black.a0c28bf3.svg";